// Curated case studies are separate from generated GitHub contribution data.
// Project repositories and demos are private. Add links only once made public.
export const projects = [
  {
    id: "stategen",
    title: "StateGen",
    subtitle: "Code generation as a Markov decision process",
    category: "AI SOFTWARE",
    visual: "code",
    featured: true,
    summary:
      "Multi-agent code generation with explicit verification, localized recovery, and semantic memory.",
    tags: ["Multi-agent systems", "Code generation", "Semantic retrieval"],
    challenge:
      "Build a code-generation workflow that can execute, verify, and recover from failures through explicit postconditions.",
    contribution: [
      "Co-developed a multi-agent framework that treats code generation as a Markov decision process.",
      "Implemented localized recovery of failed execution segments.",
      "Implemented semantic memory retrieval using sentence-transformer embeddings.",
    ],
    flow: ["Generate", "Execute", "Verify", "Recover"],
    outcome:
      "Achieved up to 99.5% pass@1 on DS-1000. Matched Self-Debugging performance on BigCodeBench while reducing token usage by 51.7%.",
    metrics: [
      { value: "99.5%", label: "Up to pass@1 · DS-1000" },
      { value: "51.7%", label: "Less token usage · BigCodeBench" },
    ],
    note:
      "Results reported in my CV. The token comparison is against Self-Debugging on BigCodeBench; the DS-1000 result is a separate benchmark. Code and detailed evaluation artifacts are private.",
  },
  {
    id: "hillsafe",
    title: "HillSafe",
    subtitle: "Landslide monitoring from sensor to dashboard",
    category: "FULL-STACK + EMBEDDED",
    visual: "sensor",
    featured: true,
    summary:
      "An STM32 monitoring system with environmental sensors, SMS alerts, and a Node.js / React dashboard.",
    tags: ["STM32", "Node.js", "React", "GSM"],
    challenge:
      "Connect environmental sensing to alerts and a dashboard for viewing and exporting monitoring data.",
    contribution: [
      "Built an embedded monitoring system using an STM32 microcontroller and environmental sensors.",
      "Integrated GSM-based SMS alerts.",
      "Developed a dashboard with geolocation, live and simulated data views, alert displays, and JSON/CSV export.",
    ],
    flow: ["Sense", "Process", "Alert", "Visualize"],
    outcome:
      "Connected hardware monitoring with a web interface that supports location context, alerts, and data export.",
    metrics: [],
    note:
      "The diagrams here illustrate the workflow; they are not live sensor readings. Repository and demo links remain private.",
  },
  {
    id: "solar-analytics",
    title: "Solar adoption analytics",
    subtitle: "Geospatial machine learning for renewable energy",
    category: "GEOSPATIAL ML",
    visual: "solar",
    featured: false,
    summary:
      "Computer vision and geospatial processing to map solar infrastructure across Madagascar.",
    tags: ["Computer vision", "Deep learning", "GIS", "Data pipelines"],
    challenge:
      "Use satellite, drone, and GIS data to support studies of renewable-energy adoption and infrastructure targeting.",
    contribution: [
      "Developed computer vision pipelines to detect solar infrastructure in satellite and drone imagery.",
      "Automated geospatial preprocessing and feature extraction.",
      "Trained and evaluated deep learning models for imagery inference, and processed datasets to map adoption across Madagascar.",
    ],
    flow: ["Imagery", "Preprocess", "Detect", "Map"],
    outcome:
      "Built processing and inference workflows to support renewable-energy mapping and infrastructure-targeting studies.",
    metrics: [],
    note:
      "Project materials are private. No detection-accuracy figures or geographic coverage totals are published here.",
  },
  {
    id: "robot-learning",
    title: "Adversarial robot learning",
    subtitle: "Physical interaction and co-adaptation",
    category: "ROBOTICS RESEARCH",
    visual: "robot",
    featured: false,
    summary:
      "Learning how a robot arm can control a mobile robot through physical bumper interactions, without a software connection.",
    tags: ["Reinforcement learning", "GPU simulation", "System identification"],
    status: "2026 — Present",
    challenge:
      "Investigate learning-based control under uncertainty when two robots interact physically without a software connection.",
    contribution: [
      "Investigate reinforcement learning for a robot arm that physically controls a mobile robot through bumper interactions.",
      "Develop GPU-accelerated simulation environments and model control dynamics under uncertainty.",
      "Evaluate learning-based control against classical system-identification methods.",
    ],
    flow: ["Simulate", "Interact", "Learn", "Evaluate"],
    outcome:
      "Ongoing research into physical robot interaction, control dynamics, and comparative evaluation.",
    metrics: [],
    note:
      "Research is ongoing. The illustration is conceptual; no experimental performance claims are made here.",
  },
];
